// Constants for different requests for current reducer
export default {
  taskLogEvent: 'TASK_LOG_EVENT',
};
